module.exports = __webpack_public_path__ + "assets/img/1.79a2b74d.jpg";